import { fetchAgents, type Agent } from '@/services/agentService';
import { defineStore } from 'pinia';
import { ref, watch } from 'vue';

export const useAgentStore = defineStore('agents', () => {
  const agents = ref<Agent[]>([]);
  const isLoading = ref(false);
  const error = ref<string | null>(null);
  const selectedAgent = ref<Agent | null>(null);

  const loadAgents = async () => {
    try {
      isLoading.value = true;
      error.value = null;
      agents.value = await fetchAgents();
      console.log('Agents loaded in store:', agents.value);
    } catch (err) {
      console.error('Failed to load agents:', err);
      error.value = 'Failed to load agents';
    } finally {
      isLoading.value = false;
    }
  };

  const getAgentById = (id: string): Agent | undefined => {
    return agents.value.find((a) => a.id === id);
  };

  const setSelectedAgent = (agent: Agent | null) => {
    selectedAgent.value = agent;
  };

  const getSelectedAgent = (): Agent | null => {
    return selectedAgent.value;
  };

  const waitUntilReady = (): Promise<void> => {
    return new Promise<void>((resolve) => {
      if (!isLoading.value) {
        resolve();
      } else {
        const unwatch = watch(isLoading, (newVal) => {
          if (!newVal) {
            unwatch();
            resolve();
          }
        });
      }
    });
  };

  return {
    agents,
    isLoading,
    error,
    selectedAgent,
    loadAgents,
    getAgentById,
    setSelectedAgent,
    getSelectedAgent,
    waitUntilReady,
  };
});
